// TODO: убрать исключения линтера
import {client} from '../../App';
import axios from 'axios';
import Cookies from 'js-cookie';
import i18n from 'i18next';

import {LOCAL_STORAGE_STAND_KEY} from './constants';

import {calcStand} from './formulaHttp';
import {FROV_SIGN} from 'common/constants';

export const stand = window.localStorage.getItem(LOCAL_STORAGE_STAND_KEY) || import.meta.env.VITE_APP_API;

console.warn('🔧 Backend Configuration:', {
  stand: stand,
  localStorage: window.localStorage.getItem(LOCAL_STORAGE_STAND_KEY),
  envVariable: import.meta.env.VITE_APP_API,
  baseURL: `${stand}/api`,
  timestamp: new Date().toLocaleTimeString(),
});

const http = axios.create({
  baseURL: `${stand}/api`,
  timeout: 300000,
});

export const httpCalc = axios.create({
  baseURL: `${calcStand}/docs/api`,
  timeout: 300000,
});
const getLang = (lang: string) => (lang === 'ru' ? 'ru-RU' : 'en');
http.interceptors.request.use(
  config => {
    // Do something before request is sent
    const token = Cookies.get('token');
    if (token && config.headers) {
      config.headers.Authorization = `Bearer ${token}`;
      config.headers['Accept-Language'] = getLang(i18n.language);
    }

    console.log('📤 HTTP Request:', {
      method: config.method?.toUpperCase(),
      url: config.url,
      baseURL: config.baseURL,
      fullURL: `${config.baseURL}${config.url || ''}`,
      hasToken: !!token,
    });

    return config;
  },
  error => {
    Promise.reject(error);
  }
);

http.interceptors.response.use(
  response => {
    console.log('📥 HTTP Response:', {
      status: response.status,
      url: response.config.url,
    });
    return response.data;
  },
  error => {
    console.error('❌ HTTP Error:', {
      method: error.config?.method?.toUpperCase(),
      url: error.config?.url,
      baseURL: error.config?.baseURL,
      fullURL: `${error.config?.baseURL || ''}${error.config?.url || ''}`,
      status: error.response?.status,
      statusText: error.response?.statusText,
      errorData: error.response?.data,
    });

    if (error.response?.status === 401) {
      client.cancelQueries();
      Cookies.remove('token');
      Cookies.remove(FROV_SIGN);
      client.clear();
    }
    throw new Error(JSON.stringify(error.response.data));
  }
);

export default http;
